import React, { FC, useState } from "react";
import { Popover } from "react-tiny-popover";

import {
  ListControl,
  Button,
  Icon,
  BottomSheet,
} from "../../components/common";
import { WalletsDropdown } from "../../components/menu";
import { CHAINS_MAP } from "../../constants";
import { Wallet } from "../../types/WalletTypes";
import { isMobileMedia } from "../../utils/media";

type Props = {
  data: Wallet[];
};

export const WalletsTable: FC<Props> = ({ data }) => {
  const [selected, setSelected] = useState<Wallet | undefined>(undefined);

  return (
    <>
      <div className="w-full flex flex-col items-stretch">
        {data.map((wallet) => (
          <ListControl
            key={wallet.address}
            className="flex flex-col min-w-full items-stretch justify-stretch -mx-4"
            onClick={() => setSelected(wallet)}
          >
            <div className="flex flex-row gap-2 border-t border-gray-50 py-6 px-4">
              <div className="flex flex-col gap-2 mr-auto shrink flex-1 basis-10/12">
                <div>
                  <span className="theme-text-default">{wallet.name}</span>{" "}
                  <span className="theme-text-secondary italic">
                    ({CHAINS_MAP[wallet.chain!].name}{" "}
                    {CHAINS_MAP[wallet.chain!].tokenStandard})
                  </span>
                </div>

                <div className="theme-text-secondary break-all">
                  {wallet.address}
                </div>
              </div>

              {!isMobileMedia() && (
                <Popover
                  isOpen={selected?.id === wallet.id}
                  positions={["bottom", "left"]}
                  content={
                    <WalletsDropdown
                      id={wallet.id}
                      active={wallet.active}
                      address={wallet.address!}
                      closeDropdown={() => setSelected(undefined)}
                    />
                  }
                  padding={10}
                  align="end"
                  onClickOutside={() => setSelected(undefined)}
                >
                  <div className="hidden md:block relative">
                    <Button
                      variant={Button.variant.TERTIARY}
                      onClick={() => setSelected(wallet)}
                      icon
                    >
                      <Icon icon="Dot-Menu" size={24} disableFill />
                    </Button>
                  </div>
                </Popover>
              )}
            </div>
          </ListControl>
        ))}
      </div>

      {isMobileMedia() && (
        <BottomSheet
          isOpen={selected !== undefined}
          close={() => setSelected(undefined)}
        >
          {selected && (
            <WalletsDropdown
              id={selected.id}
              active={selected.active}
              address={selected.address!}
              closeDropdown={() => setSelected(undefined)}
              popover={false}
            />
          )}
        </BottomSheet>
      )}
    </>
  );
};
